/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Error_GenericInputs */

const es_co2_login_error_generic = /** @type {(inputs: Login_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No pudimos iniciar tu sesión. Verifica tus datos.`)
};

/**

* @param {Login_Error_GenericInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const login_error_generic = /** @type {((inputs?: Login_Error_GenericInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Error_GenericInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_login_error_generic(inputs)
});